import { Container, Typography } from '@cleartrip/ct-design-components'
import { FC } from 'react'
import { AppliedTick } from '@/assets/icons/AppliedTick'
interface FarePreAppliedCalloutProps {
    slasherCouponCode: string
    className?: string
    /** Sits on the price line itself (tupple, footer) instead of stacked under it (fare cards). */
    inline?: boolean
    color?: string
}

const FarePreAppliedCallout: FC<FarePreAppliedCalloutProps> = ({
    slasherCouponCode,
    className = '',
    inline = false,
    color,
}) => {
    if (!slasherCouponCode) return null

    return (
        <Container className={`flex flex-middle flex-cg-1 ${inline ? 'mr-2' : 'mt-1'} ${className}`}>
            <AppliedTick {...(color ? { fill: color } : undefined)} />
            <Typography
                color={color ? undefined : 'success'}
                style={color ? { color } : undefined}
                variant="B4CAPS"
            >
                {`${slasherCouponCode} APPLIED`}
            </Typography>
        </Container>
    )
}

export default FarePreAppliedCallout
